import { GET_COMPANY_DETAILS } from "resources/actionTypes";

export function fetchCompanyDetails(id) {
  const data = {
    id: id,
  }
  return {
    type: GET_COMPANY_DETAILS.GET_COMPANY_DETAILS_REQUESTED,
    payload: data
  };
}
